module.exports = __webpack_public_path__ + "static/img/far2_active.1f9a11f9.png";